/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";
import { getLabel } from "Utils";

/**
 * Import required elements
 */
//import { CloseIcon } from "Components";
import CloseIcon from '@material-ui/icons/Close';
import MinimizeIcon from '@material-ui/icons/Minimize';
// Material-ui components
import { Typography, Divider } from "@material-ui/core";

import styles from "./styles";

/**
 * ButtonPopup Component
 */
function ButtonPopup({
  open,
  opened,
  makeVisible = null,
  close,
  Popup,
  Icon,
  label,
  lang,
  popupStyle = null,
  buttonStyle = null,
  popupProps = {}
}) {
  // CSS classnames
  const classes = styles({ opened });

  return (
    <div className={classes.iconButton}>
      {opened && (
        <div className={classes.popup} style={popupStyle}>
          <div className={classes.toolbar}>
            <Divider orientation="vertical" flexItem/>
            <MinimizeIcon className={classes.minimizeIcon} onClick={close} />
            <Divider orientation="vertical" flexItem/>
            {
              makeVisible &&  <CloseIcon className={classes.closeIcon} onClick={makeVisible} />
            }
          </div>
          <div className={classes.elemPopup}>
            <Popup {...popupProps} close={close} />
          </div>
        </div>
      )}
      <div className={classes.button} onClick={open} style={buttonStyle}>
        {Icon && <Icon className={classes.icon} />}
        {label && (
          <Typography>
            {typeof label === "string"
              ? label
              : getLabel(label, lang, "Footer/ButtonPopup")}
          </Typography>
        )}
      </div>
    </div>
  );
}

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang
}))(ButtonPopup);
